// extracted by css-extract-rspack-plugin
export default {"notebookContainer":"F7eXT"};